import { render } from "./ShareOfVoice.vue?vue&type=template&id=2f7190da"
import script from "./ShareOfVoice.vue?vue&type=script&lang=js"
export * from "./ShareOfVoice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__